const hasTwoFactorAuth = ["homolog", "cartola", "podersports"];

export default hasTwoFactorAuth;
